module.exports = __webpack_public_path__ + "static/media/craig jnr.f15771d7.jpg";